import { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Logo } from "@/components/brand/Logo";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/format";
import { Seo } from "@/components/seo/Seo";
import { SEO } from "@/data/seo";

const Field = ({ label, id, ...props }) => (
  <label htmlFor={id} className="block">
    <span className="text-[15px] font-medium text-navy">{label}</span>
    <input id={id} {...props} className="mt-2 h-14 w-full rounded-2xl border border-navy/20 bg-cream px-5 text-lg text-navy outline-none transition-colors focus:border-copper" />
  </label>
);

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin", { replace: true });
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="grid min-h-screen lg:grid-cols-2" data-testid="admin-login-page">
      <Seo {...SEO.private} />
      <div className="relative hidden overflow-hidden lg:block">
        <img src="/images/scene-bath.jpg" alt="" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-navy/70" />
        <div className="relative flex h-full flex-col justify-end p-16 text-ivory">
          <p className="font-display text-5xl leading-tight">Area riservata<br /><em className="text-copper-light">Perfero®</em></p>
        </div>
      </div>
      <div className="flex flex-col justify-center px-6 py-16 sm:px-16">
        <Link to="/" className="inline-flex items-center gap-2 text-[15px] text-slate2 hover:text-navy" data-testid="admin-back-home"><ArrowLeft className="h-4 w-4" /> Torna al negozio</Link>
        <div className="mt-10"><Logo /></div>
        <h1 className="mt-10 font-display text-4xl font-medium text-navy">Accedi al pannello</h1>
        <form onSubmit={submit} className="mt-8 max-w-md space-y-5" data-testid="admin-login-form">
          <Field label="Email" id="admin-email" type="email" autoComplete="username" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-login-email" />
          <Field label="Password" id="admin-password" type="password" autoComplete="current-password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-login-password" />
          {error && <p role="alert" className="text-[15px] text-destructive" data-testid="admin-login-error">{error}</p>}
          <button type="submit" disabled={loading} className="btn-primary w-full" data-testid="admin-login-submit">{loading ? "Accesso in corso…" : "Accedi"}</button>
        </form>
      </div>
    </div>
  );
}
